import { useEffect, useRef } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { usePrevious } from 'react-use';
export const useOnExitRoute = (route, callback) => {
    const callbackRef = useRef(callback);
    const match = useRouteMatch(route);
    const prevMatch = usePrevious(match);
    const isExitingRoute = !match && prevMatch;
    useEffect(() => {
        if (isExitingRoute) {
            callbackRef.current();
        }
    }, [isExitingRoute]);
};
